export default {
  activeTreeId: null,
  detailsId: null,
  name: null,
  homePerson: null,
  mapImageHash: null,
  mapImage: null,
  mapImageScale: 0.04,
  mapImageLoading: false,
  isMiniMapVisible: null,
  refreshRequest: false,
  startPersonId: null,
  startPersonY: null,
  focusPersonId: null,
  cardMenuShownCardId: null,
  drawLoading: null,
  hasDetachedSubtrees: false,
  detachedSubtrees: [],
  detachedSubtreesTreeId: null,
  detachedSubtreesLoading: false,
  detachedSubtreesLoadingTreeId: null,
  isWriteAllowed: false,
  isUserOwner: false,
  isPublic: false,
  preferences: {},
  bloodRelativesIds: [],

  isLangChinese: false,

  treeWidth: null,
  treeHeight: null,
  personsDrawn: null,
  linesDrawn: null,
  treeMarginX: 0,

  list: null,
  listLoading: null,
  updateLoadingById: {},

  personsSearchList: [],
  personsSearchListMeta: null,
  personsSearchListLoading: null,
  personsSearchListRequestId: 0,

  mostTaggedLocations: [],
  mostTaggedLocationsLoading: null,

  surnames: [],
  surnamesLoading: null,
  treeClanMeta: {},

  details: null,
  detailsLoading: null,

  treeAddMembersLoading: false,
  treeEditMemberLoading: {},
  treeDeleteMemberLoading: {},
  familytreeContentShares: [],
  familytreeContentSharesLoading: false,
  familytreeContentShareAcceptLoadingByEmail: {},

  breadcrumbs: null,
  isExpandControlChanged: false,

  createPrefillSurnames: null,

  allPhotos: [],

  treeOwnershipData: null,
  treeOwnershipDataLoading: null,
  treeOwnershipDataSearch: null,
  treeOwnershipDataSearchLoading: null,
  recentTreeOwners: [],
};
